import { render, staticRenderFns } from "./MySignatureFromVerificationCode.vue?vue&type=template&id=c2fab264&scoped=true"
import script from "./MySignatureFromVerificationCode.vue?vue&type=script&lang=js"
export * from "./MySignatureFromVerificationCode.vue?vue&type=script&lang=js"
import style0 from "./MySignatureFromVerificationCode.vue?vue&type=style&index=0&id=c2fab264&prod&lang=scss&scoped=true"
import style1 from "./MySignatureFromVerificationCode.vue?vue&type=style&index=1&id=c2fab264&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2fab264",
  null
  
)

export default component.exports